import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"ma-0 pa-0",staticStyle:{"height":"calc(100vh - 110px)"}},[_c('h4',{attrs:{"id":"titulo"}},[_vm._v("Detalhes do fornecedor")]),_c('div',{staticClass:"pl-1",staticStyle:{"height":"47.4%"}},[_c('MovimentacoesEstoque',{class:{},attrs:{"filtros":{
        grupos: Number(_vm.grupoCompra) > 0 ? [_vm.grupoCompra] : [],
        filiais: Number(_vm.filialCompra) > 0 ? [_vm.filialCompra] : [],
        fornecedores: _vm.idFornecedorSelecionado ? [_vm.idFornecedorSelecionado] : [],
        grupo_analise_fornecedores: _vm.getFornecedor.grupo_analise_fornecedores || false,
        atualizar_tela_compra_count_global: _vm.atualizar_tela_compra_count_global,
      }}})],1),_c(VDivider),_c('ChatStatusPerdaDeVendaPorRuptura',{staticStyle:{"height":"47.4%"},attrs:{"tela-compra":true,"tela_compra":"","filtros":{
      grupos: Number(_vm.grupoCompra) > 0 ? [_vm.grupoCompra] : [],
      filiais: Number(_vm.filialCompra) > 0 ? [_vm.filialCompra] : [],
      fora_de_linha: false,
      inativo_revenda: false,
      compradores: [],
      segmentos: [],
      fornecedores: _vm.idFornecedorSelecionado ? [_vm.idFornecedorSelecionado] : [],
      grupo_analise_fornecedores: _vm.getFornecedor.grupo_analise_fornecedores || false,
      atualizar_tela_compra_count_global: _vm.atualizar_tela_compra_count_global,
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }